import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contenedor-expedientes-medicos',
  templateUrl: './contenedor-expedientes-medicos.component.html',
  styleUrls: ['./contenedor-expedientes-medicos.component.scss']
})
export class ContenedorExpedientesMedicosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
